<div class="batch-creation-container">
  <div class="batch-creation-header">
    <span class="header-title">{{ 'createNewBatch' | translate }}</span>
  </div>
  <div class="batch-content-columns">
    <!-- Batch Settings Column -->
    <div class="batch-settings-column column">
      <app-batch-settings
        departmentsPrivs="CREATE_BATCH"
        [batchFormGroup]="batchFormGroup"
        [tenantId]="tenantId"
      >
      </app-batch-settings>
    </div>

    <!-- Upload Documents Column -->
    <div class="upload-documents-column column">
      <span class="column-header"
        >{{ 'uploadDocuments' | translate }}
        <span class="required-text">*</span>
      </span>
      <app-file-uploader
        aria-required="true"
        [tenantId]="tenantId"
        (uploadedDocumentIdsEvent)="setFileIdsToAssociate($event)"
        (uploadStatusEvent)="onUploadStatusUpdate($event)"
        (errorEvent)="handleDocumentUploadError($event)"
      >
      </app-file-uploader>
    </div>

    <!-- Upload Status Column -->
    <div class="upload-status-column column">
      <span class="column-header">{{ 'uploadStatus' | translate }}</span>
      <div class="upload-status-section">
        <div
          class="upload-status-summary"
          role="button"
          tabindex="0"
          [attr.aria-expanded]="isExpanded"
          [attr.aria-label]="
            isExpanded ? 'Collapse upload status' : ('Expand upload status' | translate)
          "
          (click)="toggleUploadStatus()"
          (keydown.enter)="toggleUploadStatus()"
          (keydown.space)="toggleUploadStatus()"
        >
          <div class="status-summary-content">
            <div class="summary-text">
              <span class="summary-title">
                {{ 'uploading' | translate }} {{ uploadStatuses.length }} {{ 'files' | translate }}
              </span>
              <span class="summary-description">
                {{ uploadedCount() }}/{{ uploadStatuses.length }} {{ 'filesUploaded' | translate }}
              </span>
            </div>
            <i
              class="arrow-icon"
              [ngClass]="isExpanded ? 'fa-solid fa-caret-up' : 'fa-solid fa-caret-down'"
            ></i>
          </div>
        </div>
        @if (isExpanded) {
          <div class="upload-status-details">
            @for (file of uploadStatuses; track file) {
              <div class="file-upload-detail">
                <span class="file-name">{{ file.file.name }}</span>
                <span class="spinner-span">
                  <ngx-spinner
                    color="#006CFA"
                    bdColor="rgba(255,255,255,0.3)"
                    size="small"
                    type="ball-spin-clockwise"
                    [name]="'uploadSpinner-' + file.index"
                    [fullScreen]="false"
                  ></ngx-spinner>
                </span>
                @if (file.status === 'completed') {
                  <span>
                    <i class="success-icon fa-solid fa-circle-check"></i>
                  </span>
                }
                @if (file.status === 'failed') {
                  <span>
                    <i class="error-icon fa-solid fa-circle-exclamation"></i>
                  </span>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Bottom Section: Batch Creation Buttons -->
  <div class="batch-creation-buttons">
    <p-button
      class="dap-cancel-batch-creation cancel-button"
      variant="text"
      [label]="'cancel' | translate"
      [ariaLabel]="'cancel' | translate"
      (click)="cancelBatchCreation()"
    >
    </p-button>
    <!-- TODO: Add validation and errors when required fields arent filled out -->
    <p-button
      class="dap-batch-create create-button"
      severity="secondary"
      size="large"
      [label]="'create' | translate"
      [ariaLabel]="'create' | translate"
      [disabled]="!canCreateBatch()"
      (click)="createBatch()"
    >
    </p-button>
  </div>
</div>
<p-toast
  position="bottom-right"
  key="errorToast"
  class="error-toast"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
        @if (message.data) {
          <span>{{ message.data }}</span>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
